import { LoginEmbarcadora } from "../login/loginEmbarcadora";
import { getAllowedMenusForShipper } from "../services/auth/api";
import MenuNavegacaoBase from "./MenuNavegacaoBase";

/**
 * Layout global do login de embarcadora. Todo o comportamento está em
 * MenuNavegacaoBase; aqui ficam só as diferenças em relação ao cliente.
 */
export default class MenuNavegacaoEmbarcadora extends MenuNavegacaoBase {
    /**
     * @param {string} embarcadoraLogada
     * @param {{CAB_CODIGO: number, CAB_RAZAO: string}[]} filiaisLogadas
     */
    constructor(embarcadoraLogada, filiaisLogadas) {
        super(
            embarcadoraLogada,
            filiaisLogadas,
            "Trocar de Embarcadora/Filial",
        );
    }

    /** Endpoint próprio, servido pelo Go e não pelo hera. */
    carregarMenusPermitidos() {
        return getAllowedMenusForShipper();
    }

    /** O menu do embarcador nunca teve as telas internas de Cadastros. */
    incluiTelasInternas() {
        return false;
    }

    reabrirSelecaoDeContexto() {
        new LoginEmbarcadora();
    }
}
